export default __webpack_public_path__ + "static/media/Gellix-BoldItalic.74c06d88.woff2";